var Footer = function Footer(props) {
  return null;
};

export default Footer;